<script>
export default {
  data () {
    return {
      onlyInputNumbers: 'return (event.charCode >= 48 && event.charCode <= 57) || event.key === "Backspace" || (event.keyCode >= 37 && event.keyCode <= 40) || event.keyCode == 46'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/OnlyInputNumber.vue